module.exports = __webpack_public_path__ + "media/assets/icons/plus-blue-700-e1113f226a14c5683a3aa2be3a70f5bf.svg";